<div class="message-container {{ containerStyle }}">
  <div
    *ngIf="start && start.type === 'material-icon'"
    class="fx-center">
    <mat-icon
      class="start-icon {{ start.cssCustomClass }}"
      [fontIcon]="start.icon"
      (click)="startIconClick.emit()">
    </mat-icon>
  </div>
  <div
    *ngIf="start && start.type === 'ionic-icon'"
    class="fx-center">
    <ion-icon
      class="start-icon {{ start.cssCustomClass }}"
      slot="icon-only"
      [name]="start.icon"
      (click)="startIconClick.emit()">
    </ion-icon>
  </div>
  <div class="fx-g-1 fx-row">
    <ng-content></ng-content>
  </div>
  <mat-icon
    *ngIf="end && end.type === 'material-icon'"
    class="end-icon {{ end.cssCustomClass }}"
    (click)="endIconClick.emit()">
    {{ end.icon }}
  </mat-icon>
  <ion-icon
    *ngIf="end && end.type === 'ionic-icon'"
    slot="icon-only"
    class="end-icon {{ end.cssCustomClass }}"
    [name]="end.icon"
    (click)="endIconClick.emit()">
  </ion-icon>
</div>
